<template>
  <div class="payment-container">
    <div class="flex justify-between font-bold w-full">
      <span>{{ $t('payment.total') }}</span>
      <span>¥{{ formattedAmount }}</span>
    </div>

    <div>
      <div class="flex mt-4">
        <icon-visa></icon-visa>
        <icon-master class="ml-2"></icon-master>
        <icon-jcb class="ml-2"></icon-jcb>
        <icon-amex class="ml-2"></icon-amex>
        <icon-diners class="ml-2"></icon-diners>
      </div>

      <t-select
        v-if="isGMOPaypal"
        v-model="selectedCardBrand"
        :label="$t('credit_card.card_brand') + '*'"
        :options="cardBrands"
        :placeholder="$t('credit_card.select_card_brand')"
        class="mt-4"
      ></t-select>

      <div :class="{ 'payment-form-mask': isGMOPaypal && !selectedCardBrand }">
        <pay-pal-form
          v-show="showPaypalForm"
          class="mt-4"
          v-bind="{ loading, disabled, expectedBrands, amount }"
          @submit="handleSubmit"
        ></pay-pal-form>
        <credit-card-form
          v-show="!showPaypalForm"
          v-bind="{ loading, disabled }"
          v-on="$listeners"
          @submit="handleSubmit"
        ></credit-card-form>
      </div>
    </div>
  </div>
</template>

<script>
import TSelect from 'ChatWidget/Common/TSelect'
import IconDiners from 'assets/icons/cc/diners.svg?inline'
import IconJcb from 'assets/icons/cc/jcb.svg?inline'
import IconMaster from 'assets/icons/cc/master.svg?inline'
import IconVisa from 'assets/icons/cc/visa.svg?inline'
import IconAmex from 'assets/icons/cc/amex.svg?inline'
import { ThirdPartyPayment } from 'javascript/Constants'
import PayPalForm from 'ChatWindow/Payment/PayPalForm'
import CreditCardForm from 'ChatWindow/Payment/CreditCardForm'
import { mapState } from 'pinia'
import { useSettingsStore } from 'Store/settings'

export default {
  name: 'PaymentForm',

  components: {
    CreditCardForm,
    PayPalForm,
    TSelect,
    IconDiners,
    IconJcb,
    IconMaster,
    IconVisa,
    IconAmex
  },

  props: {
    loading: Boolean,
    disabled: Boolean,
    amount: { type: [Number, String], required: true }
  },

  data() {
    return {
      selectedCardBrand: null
    }
  },

  computed: {
    ...mapState(useSettingsStore, {
      paymentGatewaySetting: 'paymentGatewaySetting'
    }),

    formattedAmount() {
      return Number(this.amount?.toString().replace(/\.0{0,2}$/, '')).toLocaleString()
    },

    expectedBrands() {
      if (!this.isGMOPaypal) {
        return []
      }

      if (this.gmoPaypalGateway === 'paypal') {
        return ['visa', 'mastercard']
      } else if (this.gmoPaypalGateway === 'gmo') {
        return ['jcb', 'americanexpress', 'dinersclub']
      }

      return []
    },

    cardBrands() {
      return [
        { value: 'visa', text: this.$t('gmoPaypalOptions.visa') },
        { value: 'mastercard', text: this.$t('gmoPaypalOptions.master') },
        { value: 'jcb', text: this.$t('gmoPaypalOptions.jcb') },
        { value: 'americanexpress', text: this.$t('gmoPaypalOptions.amex') },
        { value: 'dinersclub', text: this.$t('gmoPaypalOptions.diners') }
      ]
    },

    gmoPaypalGateway() {
      if (!this.isGMOPaypal) return null

      if (['visa', 'mastercard'].includes(this.selectedCardBrand)) {
        return 'paypal'
      }

      if (['jcb', 'americanexpress', 'dinersclub'].includes(this.selectedCardBrand)) {
        return 'gmo'
      }

      return null
    },

    showPaypalForm() {
      return this.isGMOPaypal && this.gmoPaypalGateway !== 'gmo'
    },

    isGMOPaypal() {
      return this.paymentGatewaySetting?.name === ThirdPartyPayment.GMOPayPal
    }
  },

  methods: {
    handleSubmit(cardData) {
      this.$emit('submit', {
        ...cardData,
        payment_gateway: this.gmoPaypalGateway || this.paymentGatewaySetting?.name
      })
    }
  }
}
</script>
